import { render, staticRenderFns } from "./RightBar.vue?vue&type=template&id=80482164&scoped=true&"
import script from "./RightBar.vue?vue&type=script&lang=js&"
export * from "./RightBar.vue?vue&type=script&lang=js&"
import style0 from "./RightBar.vue?vue&type=style&index=0&id=80482164&prod&lang=scss&"
import style1 from "./RightBar.vue?vue&type=style&index=1&id=80482164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80482164",
  null
  
)

export default component.exports